import styled from 'styled-components';

import { ConversationTitle } from '@domains/new-conversation/pages/Conversation.styled';
import { breakpoints } from '@shared/constants';

export const SummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    padding: 0 15px;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        margin: 0;
    }
`;

export const SummaryTitle = styled(ConversationTitle)`
    margin-bottom: 8px;
`;
